//import Swiper from 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.mjs'

///////////////////////
// AGE GATE
///////////////////////
document.addEventListener('DOMContentLoaded', function () {
    var ageGateModal = document.getElementById('age-gate-modal');
    var confirmButton = document.getElementById('confirm-age');
    var body = document.querySelector('body');

    // Trier les select
    var select = document.getElementById("countryList");
    if (select) {
        var options = Array.from(select.options);
        options.sort(function (a, b) {
            var textA = a.text.toUpperCase();
            var textB = b.text.toUpperCase();
            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
        });
        select.innerHTML = "";
        options.forEach(function (option) {
            select.add(option);
        });
    }


    // Vérifie si l'utilisateur a déjà confirmé son âge
    if (!localStorage.getItem('ageConfirmed')) {
        if (ageGateModal) {
            ageGateModal.style.opacity = '0'; // Réglez l'opacité à 0 initialement
            ageGateModal.style.display = 'flex';
            //body.classList.add("fixed");

            setTimeout(function () {
                ageGateModal.style.opacity = '1'; // Changez l'opacité à 1 pour l'effet fadeIn
            }, 10);
        }

    }

    // L'utilisateur change de langue
    var langueSelect = document.getElementById('langue');
    if (langueSelect) {
        langueSelect.addEventListener('change', function () {
            var selectedUrl = langueSelect.value;
            if (selectedUrl) {
                window.location.href = selectedUrl;
            }
        });
    }

    // Champs année vide ?
    const form = document.getElementById('formAgeGate');
    const anneeNaissanceInput = document.getElementById('annee_naissance');
    const erreurAnneeNaissance = document.getElementById('erreur_annee_naissance');
    const erreurAge = document.getElementById('error_age');

    if (form) {
        form.addEventListener('submit', function (event) {
            event.preventDefault(); // Empêche la soumission du formulaire

            var selectElement = document.getElementById('countryList');
            var selectedIndex = selectElement.selectedIndex;
            if (selectedIndex !== -1) {
                var selectedOption = selectElement.options[selectedIndex];
                var dataAgeValue = selectedOption.getAttribute('data-age');
            }

            if (!anneeNaissanceInput.value.trim()) {
                erreurAnneeNaissance.textContent = 'Veuillez entrer votre année de naissance.'; // Affiche le message d'erreur
            } else {
                erreurAnneeNaissance.textContent = ''; // Efface le message d'erreur s'il y en a un
                const anneeDeNaissance = anneeNaissanceInput.value;
                const age = calculerAge(anneeDeNaissance);
                dataAgeValue = parseInt(dataAgeValue) - 1;

                if (age > dataAgeValue) {
                    localStorage.setItem('ageConfirmed', 'true');
                    ageGateModal.style.opacity = '0'; // Réglez l'opacité à 0 initialement
                    body.classList.remove("fixed");

                    setTimeout(function () {
                        ageGateModal.style.display = 'none';
                        window.scrollTo({
                            top: 0,
                            behavior: 'smooth'
                        });
                    }, 1000);

                    var autoplayVideos = document.querySelectorAll(".js-bal_cloudinary-video.autoplay");
                    autoplayVideos.forEach(function (video) {
                        function restartVideo() {
                            video.currentTime = 0;  // Réglez le temps de lecture à 0 (le début de la vidéo)
                            video.play();           // Commencez la lecture
                        }

                        restartVideo();
                    });
                } else {
                    erreurAge.textContent = "Vous n'avez pas l'âge légal pour entrer sur ce site";
                }
            }
        });
    }
});

// Fonction pour calculer l'age
function calculerAge(anneeNaissance) {
    const anneeActuelle = new Date().getFullYear();
    const age = anneeActuelle - anneeNaissance;
    return age;
}

// Fonction pour détecter la langue du navigateur
function getBrowserLang() {
    return navigator.language || navigator.userLanguage;
}

// Fonction pour mettre à jour la liste des pays en fonction de la langue sélectionnée
function updateCountryList() {
    const browserLang = getBrowserLang();
    const langueSelect = document.getElementById('langue');
    const countryList = document.getElementById('countryList');
}

// Fonction pour mettre à jour les options de la liste des pays
function updateCountryOptions(values, texts) {
    const countryList = document.getElementById('countryList');

    // Supprimer toutes les options actuelles
    countryList.innerHTML = '';

    // Ajouter les nouvelles options
    for (let i = 0; i < values.length; i++) {
        const option = document.createElement('option');
        option.value = values[i];
        option.text = texts[i];
        countryList.appendChild(option);
    }
}

// Fonction pour détecter le pays de l'internaute
function detectUserCountry() {
    fetch('https://ipapi.co/json/')
        .then(response => response.json())
        .then(data => {
            // Utilisez la propriété country_name pour obtenir le nom du pays
            const userCountry = data.country_name;

            // Sélectionnez le pays dans la liste
            const countryList = document.getElementById('countryList');
            const option = Array.from(countryList.options).find(opt => opt.text.includes(userCountry));
            if (option) {
                countryList.value = option.value;
            }
        })
        .catch(error => {
            console.error('Erreur lors de la détection du pays :', error);
        });
}

// Ajouter un gestionnaire d'événements pour détecter les changements de langue
var langueElement = document.getElementById('langue');
if (langueElement) {
    langueElement.addEventListener('change', updateCountryList);

// Appeler la fonction lors du chargement de la page pour détecter le pays de l'internaute
    detectUserCountry();
// Appeler la fonction lors du chargement de la page
    updateCountryList();
}
// STICKY

// Sélection du header
const header = document.getElementById('header'); // Remplace 'monHeader' par l'ID de ton header

// Variable pour stocker la position précédente du défilement
let previousScrollPosition = window.scrollY;

// Ajout d'un écouteur d'événements pour le défilement
window.addEventListener('scroll', function () {
    // Obtention de la position actuelle du défilement
    const currentScrollPosition = window.scrollY;

    // Vérification si le défilement est vers le haut et le header n'est pas déjà fixé
    if (currentScrollPosition < previousScrollPosition && !header.classList.contains('fixed')) {
        // Ajout de la classe "fixed" au header
        header.classList.add('fixed');
        document.body.classList.add('fixed-menu');
    } else if (currentScrollPosition > previousScrollPosition && header.classList.contains('fixed')) {
        // Retrait de la classe "fixed" du header lorsque l'utilisateur fait défiler vers le bas
        header.classList.remove('fixed');
        document.body.classList.remove('fixed-menu');
    }

    // Vérification si l'utilisateur est tout en haut de la page
    if (currentScrollPosition === 0) {
        // Retrait de la classe "fixed" lorsque l'utilisateur est tout en haut
        header.classList.remove('fixed');
        document.body.classList.remove('fixed-menu');
    }

    // Mise à jour de la position précédente du défilement
    previousScrollPosition = currentScrollPosition;
});


// OPEN / CLOSE MENU
document.addEventListener('DOMContentLoaded', function () {
    const body = document.body;
    const menuCollections = document.getElementById('all-collections');
    const toggleMenu = document.getElementById('menu-open-collections');
    const toggleMenuM = document.getElementById('open-collections');
    const toggleMenusBack = document.querySelectorAll('.close-collections-back');
    const labelBis = document.querySelector('label[for="menu-toggle"] .text');
    const checkboxBis = document.getElementById('menu-toggle');

    function toggleActiveMenuClasses() {
        body.classList.toggle('active-menu', checkboxBis.checked);
        menuCollections.classList.remove('active');
        toggleMenu.classList.remove('active');
        body.classList.remove('active-menu-collections', 'active-menu-collections-desktop');
        const labelText = checkboxBis.checked ? labelBis.dataset.close : labelBis.dataset.open;
        labelBis.textContent = labelText;

    }

    if (checkboxBis) {
        checkboxBis.addEventListener('change', toggleActiveMenuClasses);
    }


    if (toggleMenu) {
        toggleMenu.addEventListener('click', function (e) {
            e.preventDefault();
            menuCollections.classList.toggle('active');
            toggleMenu.classList.toggle('active');
            body.classList.toggle('active-menu-collections-desktop');
        });
    }


    if (toggleMenusBack) {
        toggleMenusBack.forEach(function (toggleMenuMBack) {
            toggleMenuMBack.addEventListener('click', function (e) {
                e.preventDefault();
                menuCollections.classList.toggle('active');
                body.classList.toggle('active-menu-collections');
            });
        });
    }

    if (toggleMenuM) {
        toggleMenuM.addEventListener('click', function (e) {
            e.preventDefault();
            menuCollections.classList.toggle('active');
            body.classList.toggle('active-menu-collections');
        });
    }
});

// COUNT TYPE BLOCK 50/50

document.addEventListener('DOMContentLoaded', () => {
    // Fonction pour ajouter un compteur aux éléments Gutenberg de type "image"
    const ajouterCompteurAuxImages = () => {
        // Sélectionner tous les blocs de type "image"
        const images = document.querySelectorAll('.gutenberg-text-img.classic');
        // Parcourir chaque bloc
        images.forEach((image, index) => {
            // Ajouter une classe avec le compteur au bloc
            image.classList.add(`item-${index + 1}`);
        });
    };
    // Appeler la fonction lorsque le document est prêt
    ajouterCompteurAuxImages();
});


/// SCROLL SMOOTH

document.addEventListener('DOMContentLoaded', () => {
    const smoothScroll = (targetId) => {
        const targetElement = document.querySelector('[id="' + targetId + '"]');
        var vinMenu = document.getElementById('vin-menu');

        if (targetElement) {

            if (vinMenu) {
                var vinMenuHeight = vinMenu.offsetHeight;
                var topAnchor = targetElement.offsetTop - vinMenuHeight;
            } else {
                var topAnchor = targetElement.offsetTop;
            }

            var collectionMenu = document.getElementById('menu-collection');

            if (collectionMenu) {
                var premierItem = collectionMenu.querySelector('.item');
                var collectionMenuHeight = premierItem.offsetHeight;
                var topAnchor = targetElement.offsetTop - collectionMenuHeight;
            } else {
                var topAnchor = targetElement.offsetTop;
            }

            window.scrollTo({
                top: topAnchor,
                behavior: 'smooth'
            });
        }
    };


    const smoothScrollCollection = (targetId) => {
        const targetElement = document.querySelector('[id="' + targetId + '"]');
        var headerMenu = document.getElementById('header');
        headerMenu = headerMenu.offsetHeight;
        var bottomCollection = document.querySelector('.gutenberg-hero-title');
        bottomCollection = bottomCollection.offsetHeight;
        var topAnchor = bottomCollection - headerMenu;
        if (targetElement) {
            window.scrollTo({
                top: topAnchor,
                behavior: 'smooth'
            });
        }
    };

    const anchorLinks = document.querySelectorAll('a[href^="#"]');
    anchorLinks.forEach((anchor) => {
        anchor.addEventListener('click', (e) => {
            e.preventDefault();
            const targetId = anchor.getAttribute('href').substring(1);
            if (targetId == "filter-par-vin") {
                smoothScrollCollection(targetId);
            } else {
                smoothScroll(targetId);
            }
        });
    });
});

/// SCROLL TOP SMOOTH

// Show/hide the "Scroll to Top" button based on scroll position
window.onscroll = function () {
    scrollFunction();
};

function scrollFunction() {
    var innerHeight = window.innerHeight;
    var scrollToTopBtn = document.getElementById("back-to-top");
    if (document.body.scrollTop > innerHeight || document.documentElement.scrollTop > innerHeight) {
        scrollToTopBtn.style.opacity = "1";
    } else {
        scrollToTopBtn.style.opacity = "0";
    }
}

/// PAGE VIGNERONS > FIXER LA FLECHE DU HERO

const gutenbergHeroTitle = document.querySelector('.gutenberg-hero-title.portraits');
if (gutenbergHeroTitle !== null) {
    const arrowHero = document.querySelector('.gutenberg-hero-title.portraits .arrow');
    const nextDiv = document.querySelector('.gutenberg-hero-title.portraits').nextElementSibling;

    // Options pour l'Intersection Observer (vous pouvez ajuster selon vos besoins)
    const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0
    };
    // Fonction de rappel à exécuter lorsqu'il y a une intersection
    const callback = (entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                arrowHero.classList.remove("fixed");
            } else {
                // Calculer la direction du scroll en comparant les positions
                // de l'élément et du conteneur racine
                const isScrollingUp = entry.boundingClientRect.top < entry.rootBounds.top;
                const isScrollingDown = entry.boundingClientRect.top > entry.rootBounds.top;
                if (isScrollingUp) {
                } else if (isScrollingDown) {
                    arrowHero.classList.add("fixed");
                }
            }
        });
    };

    const observer = new IntersectionObserver(callback, options);

    if (nextDiv) {
        observer.observe(nextDiv);
    }
}

// LAZY LOAD BACKGROUND

document.addEventListener("DOMContentLoaded", function () {
    var lazyBackgrounds = [].slice.call(document.querySelectorAll(".lazy-background"));
    if ("IntersectionObserver" in window) {
        var lazyBackgroundObserver = new IntersectionObserver(function (entries, observer) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    entry.target.style.backgroundImage = entry.target.getAttribute("data-bg");
                    lazyBackgroundObserver.unobserve(entry.target);
                }
            });
        });
        lazyBackgrounds.forEach(function (lazyBackground) {
            lazyBackgroundObserver.observe(lazyBackground);
            console.log("observe");
        });
    } else {
        // Si IntersectionObserver n'est pas pris en charge, chargez l'image immédiatement.
        lazyBackgrounds.forEach(function (lazyBackground) {
            lazyBackground.style.backgroundImage = lazyBackground.getAttribute("data-bg");
        });
    }
});
